module.exports = __webpack_public_path__ + "img/SL-M-220-290.9f0f2df1.svg";